import PropTypes from 'prop-types';
import styles from './CategoryTreeItem.module.less';
import clsx from 'clsx';
import React from 'react';
import Icon from '../../Icon';

const CategoryTreeItem = ({
  displayName,
  href,
  urlSlice,
  selected = false,
  onClick,
  hasChildren = false,
  contentRequestInProcess,
}) => {
  const handleClick = e => {
    if (e.type !== 'click' && e.key !== 'Enter') {
      return;
    }
    onClick(e, href);
  };

  const finalSelected = selected && !hasChildren;

  const classes = clsx(styles.subCategory, {
    [styles.finalSelected]: finalSelected,
    [styles.disabled]: contentRequestInProcess,
  });

  const dataCy = finalSelected
    ? 'category-link-final-selected'
    : 'category-link';

  if (selected) {
    // Navigate to parent
    href = href.replace(`${urlSlice}/`, '');
  }

  return (
    <a className={classes} onClick={handleClick} href={href} data-cy={dataCy}>
      <span className={styles.label}>{displayName}</span>
      {finalSelected && <Icon name="cancel-thin" />}
    </a>
  );
};
export default CategoryTreeItem;

CategoryTreeItem.propTypes = {
  displayName: PropTypes.string,
  selected: PropTypes.bool,
  href: PropTypes.string,
  urlSlice: PropTypes.string,
  onClick: PropTypes.func,
  hasChildren: PropTypes.bool,
  contentRequestInProcess: PropTypes.bool.isRequired,
};
